export const fbPixelConfig = {
  pixelId: '271084081942520',
  siteIdentifier: 'bbs-academy-webinar',
};
